import { FroalaEditorFunctionality } from './FroalaEditorFunctionality';
import * as React from 'react';

export class FroalaEditorImg extends FroalaEditorFunctionality {    
  render () {
    const that: any = this 
    return (
      <img ref={el => that.el = el}/>
    );
  }
}